/**
 * RulesPanel — the CUSTOM Rules tab body: exclude + capacity rules beside the
 * pinned live preview, with the rule-set library actions.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { TabsContent } from '@/components/ui/layout/Tabs';
import { RuleSetActions } from '@/features/flow-optimizer-library/picker';
import { PreviewSplitLayout } from '@/features/flow-optimizer/components/preview/panel';
import ExcludeEngineTab from '@/features/flow-optimizer/tabs/ExcludeEngineTab';

import { SPLIT_PANEL_CLASS, type CustomTabPanelsProps } from './panel-props';

const RulesPanel: FC<CustomTabPanelsProps> = ({ draft, onChange, splitActive, sidePanel }) => (
  <TabsContent value="rules" className={SPLIT_PANEL_CLASS}>
    <PreviewSplitLayout active={splitActive} panel={sidePanel}>
      <ExcludeEngineTab
        excludeRules={draft.excludeRules}
        onChange={(excludeRules) => onChange({ ...draft, excludeRules })}
        capacityRules={draft.capacityRules ?? []}
        onCapacityRulesChange={(capacityRules) => onChange({ ...draft, capacityRules })}
        formulaGroups={draft.formula.groups}
        libraryActions={
          <RuleSetActions
            excludeRules={draft.excludeRules}
            capacityRules={draft.capacityRules ?? []}
            packageId={draft.packageId}
            onApply={({ excludeRules, capacityRules }) =>
              onChange({ ...draft, excludeRules, capacityRules })
            }
          />
        }
      />
    </PreviewSplitLayout>
  </TabsContent>
);

export default RulesPanel;
